export const ADD_LOCATION_BY_STEP = 'ADD_LOCATION_BY_STEP';
export const CHANGE_TAB = 'CHANGE_TAB';

export const SUBMIT_ADD_LOCATION = 'SUBMIT_ADD_LOCATION';
export const RESET_FORM_SUCCESS = 'RESET_FORM_SUCCESS';
